var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-primary text-center py-4 text-white"},[_c('p',{staticClass:"text-sm"},[_vm._v("\n    Copyright © "+_vm._s(new Date().getFullYear())+" by "),_c('a',{staticClass:"text-white",attrs:{"href":"https://yesdok.com"}},[_vm._v("YesDok")]),_vm._v(". All Right Reserved.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }